import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { OfficialViewPage } from './official-view.page';

const routes: Routes = [
  {
    path: ':id',
    component: OfficialViewPage,
    title: 'iOnCourt | Official View'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OfficialViewPageRoutingModule {}
